"use client";
import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@packages/ui/src/components/shadcn/button";
import { Card } from "@packages/ui/src/components/shadcn/card";
import { TimeMaterialMode } from "./TimeMaterialMode";
import { ProjectWorkMode } from "./ProjectWorkMode";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";
import { useTranslation } from "react-i18next";

type WorkingMode = "timeMaterial" | "projectWork";

export const WorkingModes = () => {
  const [activeMode, setActiveMode] = useState<WorkingMode>("timeMaterial");
  const { t } = useTranslation("workmode");

  return (
    <section
      className="w-full py-12 md:py-16 bg-gradient-to-br from-gray-50 to-white"
      id="workmod"
    >
      <ContainerGlob>
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t("section.title")}
          </h2>
          <p className="text-lg text-gray-600">{t("section.subtitle")}</p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="flex flex-col sm:flex-row gap-2 w-full max-w-md sm:max-w-none sm:w-auto">
            <Button
              variant={activeMode === "timeMaterial" ? "default" : "outline"}
              onClick={() => setActiveMode("timeMaterial")}
              className="px-4 sm:px-6 py-2 text-xs sm:text-sm font-medium rounded-xl whitespace-nowrap"
            >
              {t("buttons.timeMaterial")}
            </Button>
            <Button
              variant={activeMode === "projectWork" ? "default" : "outline"}
              onClick={() => setActiveMode("projectWork")}
              className="px-4 sm:px-6 py-2 text-xs sm:text-sm font-medium rounded-xl whitespace-nowrap"
            >
              {t("buttons.projectWork")}
            </Button>
          </div>
        </div>

        <Card className="overflow-hidden shadow-lg">
          <motion.div
            key={activeMode}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            {activeMode === "timeMaterial" ? (
              <TimeMaterialMode />
            ) : (
              <ProjectWorkMode />
            )}
          </motion.div>
        </Card>
      </ContainerGlob>
    </section>
  );
};
